export default "__VITE_ASSET__CVi$PJSz__"